// ══════════════════════════════════════════════════════════════════════════════
// DÉCLINAISONS PRÉ-REMPLIES PAR RAYON
// Chaque rayon a ses propres déclinaisons avec des valeurs chips prédéfinies
// ══════════════════════════════════════════════════════════════════════════════

export const DECLINAISONS_PAR_RAYON = {
  // ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
  // RAYON 1 — Électricité
  // ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
  'rayon-electricite': [
    { id: 'couleur', name: 'Couleur', chips: ['Blanc', 'Ivoire', 'Anthracite', 'Noir', 'Inox', 'Titane'] },
    { id: 'puissance', name: 'Puissance', chips: ['9W', '12W', '18W', '36W', '60W', '100W', '500W', '1000W', '2000W', '3000W'] },
    { id: 'tension', name: 'Tension', chips: ['12V', '24V', '48V', '110V', '220V', '380V'] },
    { id: 'nb_modules', name: 'Nombre de modules', chips: ['1', '2', '4', '6', '8', '12', '18', '24', '36'] },
    { id: 'certification', name: 'Certification', chips: ['NF', 'CE', 'NF C 15-100', 'IP44', 'IP65', 'IP67', 'IK10'] },
  ],

  // ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
  // RAYON 2 — Plomberie
  // ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
  'rayon-plomberie': [
    { id: 'matiere', name: 'Matière', chips: ['PVC', 'PER', 'Cuivre', 'Inox', 'Laiton', 'PEHD', 'PPR'] },
    { id: 'diametre', name: 'Diamètre', chips: ['12mm', '16mm', '20mm', '25mm', '32mm', '40mm', '50mm', '63mm', '75mm', '100mm'] },
    { id: 'finition_robinetterie', name: 'Finition robinetterie', chips: ['Chromé', 'Noir mat', 'Or brossé', 'Inox brossé', 'Blanc mat', 'Bronze'] },
    { id: 'contenance', name: 'Contenance', chips: ['50L', '100L', '150L', '200L', '250L', '300L', '500L'] },
    { id: 'type_raccord', name: 'Type raccord', chips: ['Mâle', 'Femelle', 'Bicône', 'À sertir', 'À coller', 'À visser'] },
  ],

  // ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
  // RAYON 3 — Jardin & Paysage
  // ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
  'rayon-jardin-paysage': [
    { id: 'matiere', name: 'Matière', chips: ['Bois pin', 'Bois composite', 'Béton', 'Pierre', 'Résine', 'Aluminium', 'Acier galvanisé'] },
    { id: 'dimensions', name: 'Dimensions (L × l en m)', chips: ['1×1', '1×2', '2×2', '2×3', '3×3', '3×5', '4×5', 'Sur mesure'] },
    { id: 'coloris', name: 'Coloris', chips: ['Naturel', 'Gris', 'Anthracite', 'Brun', 'Vert', 'Blanc', 'Teck', 'Ipé'] },
    { id: 'usage', name: 'Usage', chips: ['Intérieur', 'Extérieur', 'Intérieur+Extérieur', 'Ombre', 'Soleil'] },
    { id: 'alimentation', name: 'Alimentation', chips: ['Électrique', 'Batterie', 'Thermique', 'Solaire', 'Manuel'] },
  ],

  // ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
  // RAYON 4 — Piscine & Spa
  // ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
  'rayon-piscine-spa': [
    { id: 'dimensions_piscine', name: 'Dimensions (L × l en m)', chips: ['3×6', '4×8', '5×10', '6×12', '7×14', 'Sur mesure'] },
    { id: 'profondeur', name: 'Profondeur (cm)', chips: ['90', '120', '140', '150', '180', 'Variable'] },
    { id: 'type_piscine', name: 'Type', chips: ['Enterrée', 'Hors-sol', 'Semi-enterrée', 'Débordement', 'Miroir'] },
    { id: 'finition_piscine', name: 'Finition', chips: ['Liner', 'Carrelage', 'Coque polyester', 'Béton projeté', 'Enduit marinal'] },
    { id: 'couleur_piscine', name: 'Couleur', chips: ['Bleu clair', 'Gris', 'Blanc', 'Sable', 'Ardoise', 'Vert eau', 'Noir'] },
    { id: 'nb_places', name: 'Nombre de places (Spa)', chips: ['2 places', '3 places', '4 places', '5 places', '6 places', '7 places', '8 places'] },
    { id: 'nb_jets', name: 'Nombre de jets', chips: ['10-20 jets', '20-40 jets', '40-60 jets', '60-80 jets', '80-100 jets', '+100 jets'] },
    { id: 'type_jets', name: 'Type de jets', chips: ['Dorsaux', 'Lombaires', 'Cervicaux', 'Plantaires', 'Directionnels', 'Hydromassage'] },
    { id: 'type_spa', name: 'Type de spa', chips: ['Gonflable', 'Rigide hors-sol', 'Encastrable', 'Bois', 'Acier inox'] },
    { id: 'options_spa', name: 'Options & équipements', chips: ['Éclairage LED', 'Chromothérapie', 'Audio intégré', 'PAC intégrée', 'Couverture thermique', 'Wi-Fi & App', 'Ozonateur', 'Sel'] },
  ],

  // ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
  // RAYON 5 — Peinture & Décoration
  // ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
  'rayon-peinture-decoration': [
    { id: 'finition', name: 'Finition', chips: ['Mat', 'Velours', 'Satiné', 'Semi-brillant', 'Brillant', 'Laqué'] },
    { id: 'contenance', name: 'Contenance', chips: ['500ml', '1L', '2,5L', '5L', '10L', '15L', '20L', '25L'] },
    { id: 'couleur_teinte', name: 'Couleur / Teinte', chips: ['Blanc pur', 'Blanc cassé', 'Gris clair', 'Gris', 'Beige', 'Crème', 'Jaune', 'Bleu', 'Vert', 'Rouge', 'Noir', 'Sur RAL'] },
    { id: 'support', name: 'Support', chips: ['Bois', 'Métal', 'Béton', 'Plâtre', 'Carrelage', 'Maçonnerie', 'Tous supports'] },
    { id: 'usage', name: 'Usage', chips: ['Intérieur', 'Extérieur', 'Intérieur+Extérieur', 'Sol', 'Mur', 'Plafond'] },
  ],

  // ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
  // RAYON 6 — Maçonnerie & Gros Œuvre
  // ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
  'rayon-maconnerie-gros-oeuvre': [
    { id: 'dimensions', name: 'Dimensions (cm)', chips: ['20×20×20', '50×20×20', '60×20×25', '50×25×20', '60×25×25', 'Sur mesure'] },
    { id: 'resistance', name: 'Résistance (MPa)', chips: ['2 MPa', '4 MPa', '6 MPa', '8 MPa', '12 MPa', '16 MPa', '20 MPa', '25 MPa'] },
    { id: 'type', name: 'Type', chips: ['Creux', 'Plein', 'Alvéolaire', 'Cellulaire', 'Semi-plein'] },
    { id: 'conditionnement', name: 'Conditionnement', chips: ['À la pièce', 'Lot de 10', 'Lot de 50', 'Palette (300 pcs)', 'Palette (500 pcs)'] },
    { id: 'classe_exposition', name: 'Classe d\'exposition', chips: ['XC1', 'XC2', 'XC3', 'XC4', 'XF1', 'XS1'] },
  ],

  // ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
  // RAYON 7 — Rénovation & Second Œuvre
  // ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
  'rayon-renovation-interieure': [
    { id: 'epaisseur', name: 'Épaisseur (mm)', chips: ['40', '60', '80', '100', '120', '140', '160', '200'] },
    { id: 'resistance_r', name: 'Résistance thermique R', chips: ['R2', 'R3', 'R4', 'R5', 'R6', 'R7', 'R8', 'R10'] },
    { id: 'format', name: 'Format', chips: ['Rouleau', 'Panneau', 'Semi-rigide', 'Vrac', 'Complexe'] },
    { id: 'largeur', name: 'Largeur (mm)', chips: ['400', '600', '1000', '1200', '1350'] },
    { id: 'certification', name: 'Certification', chips: ['Acermi', 'CE', 'Avis technique', 'ETICS', 'NF'] },
  ],

  // ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
  // RAYON 8 — Carrelage & Revêtements Durs
  // ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
  'rayon-carrelage-revetement': [
    { id: 'format', name: 'Format (cm)', chips: ['10×10', '20×20', '30×30', '40×40', '45×90', '60×60', '60×120', '80×80', '100×100', '120×120', 'Sur mesure'] },
    { id: 'finition', name: 'Finition', chips: ['Mat', 'Poli', 'Satiné', 'Lappato', 'Antidérapant R9', 'R10', 'R11', 'R12', 'Structuré'] },
    { id: 'epaisseur', name: 'Épaisseur (mm)', chips: ['6', '8', '9', '10', '12', '14', '20'] },
    { id: 'usage', name: 'Usage', chips: ['Sol intérieur', 'Mur intérieur', 'Sol+Mur', 'Extérieur', 'Piscine', 'Terrasse', 'Local humide'] },
    { id: 'rectifie', name: 'Rectifié', chips: ['Rectifié', 'Non rectifié'] },
    { id: 'conditionnement', name: 'Conditionnement', chips: ['Prix au m²', 'Par boîte', 'Par palette'] },
  ],

  // ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
  // RAYON 9 — Menuiserie & Fermetures
  // ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
  'rayon-menuiserie': [
    { id: 'matiere', name: 'Matière', chips: ['PVC', 'Aluminium', 'Bois', 'Mixte bois-alu', 'Acier', 'Acier blindé'] },
    { id: 'coloris_ral', name: 'Coloris / RAL', chips: ['Blanc 9016', 'Gris 7016', 'Anthracite 7021', 'Noir 9005', 'Chêne doré', 'Chêne gris', 'Chêne naturel', 'Sur RAL'] },
    { id: 'dimensions', name: 'Dimensions (l × h en cm)', chips: ['60×215', '80×215', '90×215', '100×215', '120×215', '200×215', 'Sur mesure'] },
    { id: 'vitrage', name: 'Vitrage', chips: ['Simple', 'Double 4/16/4', 'Double 4/20/4', 'Triple', 'VIR', 'Feuilleté', 'Opaque'] },
    { id: 'sens_ouverture', name: 'Sens ouverture', chips: ['Gauche', 'Droite', 'Oscillo-battant', 'Coulissant', 'Pliante'] },
    { id: 'performance_uw', name: 'Performance thermique Uw', chips: ['Uw 1,8', 'Uw 1,6', 'Uw 1,4', 'Uw 1,2', 'Uw 1,0', 'Uw 0,8'] },
    { id: 'motorisation', name: 'Motorisation', chips: ['Non motorisé', 'Motorisé radio', 'Motorisé filaire', 'Connecté app'] },
  ],

  // ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
  // RAYON 10 — Chauffage & Énergie
  // ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
  'rayon-chauffage': [
    { id: 'type_energie', name: 'Type d\'énergie', chips: ['Gaz naturel', 'GPL', 'Fioul', 'Électrique', 'Air/eau', 'Air/air', 'Géothermique', 'Granulés bois', 'Bois bûches', 'Hybride'] },
    { id: 'puissance', name: 'Puissance (kW)', chips: ['5 kW', '8 kW', '10 kW', '12 kW', '15 kW', '18 kW', '20 kW', '24 kW', '30 kW', '35 kW'] },
    { id: 'classe_energie', name: 'Classe énergétique', chips: ['A', 'A+', 'A++', 'A+++', 'B', 'C'] },
    { id: 'cop_scop', name: 'COP / SCOP', chips: ['COP 3', 'COP 3,5', 'COP 4', 'COP 4,5', 'COP 5', 'COP 5,5', 'SCOP 4', 'SCOP 4,5'] },
    { id: 'tension', name: 'Tension', chips: ['Monophasé 220V', 'Triphasé 380V'] },
    { id: 'couleur', name: 'Couleur', chips: ['Blanc', 'Gris', 'Anthracite', 'Inox'] },
  ],

  // ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
  // RAYON 11 — Couverture & Toiture
  // ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
  'rayon-couverture-toiture': [
    { id: 'matiere', name: 'Matière', chips: ['Terre cuite', 'Béton', 'Ardoise naturelle', 'Ardoise synthétique', 'Zinc', 'Acier laqué', 'EPDM', 'Bitume modifié', 'Shingle'] },
    { id: 'coloris', name: 'Coloris', chips: ['Rouge', 'Brun', 'Noir', 'Gris', 'Ardoisé', 'Vert', 'Terracotta', 'Vieilli'] },
    { id: 'format_pureau', name: 'Format / Pureau (cm)', chips: ['16', '18', '20', '22', '25', '28', '30', '35'] },
    { id: 'poids', name: 'Poids (kg/m²)', chips: ['<15 kg', '15-25 kg', '25-40 kg', '>40 kg'] },
    { id: 'certification', name: 'Certification', chips: ['NF', 'CE', 'DTU 40', 'Résistance gel', 'Résistance grêle', 'Classe feu B roof'] },
  ],

  // ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
  // RAYON 12 — Isolation & Performance Énergétique
  // ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
  'rayon-isolation': [
    { id: 'type_isolant', name: 'Type d\'isolant', chips: ['Laine de verre', 'Laine de roche', 'PSE', 'XPS', 'PUR', 'Liège', 'Fibre de bois', 'Chanvre', 'Ouate cellulose', 'Laine mouton'] },
    { id: 'epaisseur', name: 'Épaisseur (mm)', chips: ['40', '60', '80', '100', '120', '140', '160', '180', '200', '240', '300'] },
    { id: 'resistance_r', name: 'Résistance R (m².K/W)', chips: ['R2', 'R3', 'R4', 'R5', 'R6', 'R7', 'R8', 'R10'] },
    { id: 'format', name: 'Format', chips: ['Rouleau', 'Panneau', 'Semi-rigide', 'Vrac soufflé', 'Mousse projetée'] },
    { id: 'certification', name: 'Certification', chips: ['Acermi', 'CE', 'NF', 'Avis technique', 'ETICS', 'FDES', 'Bilan carbone'] },
  ],

  // ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
  // RAYON 13 — Climatisation & Ventilation
  // ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
  'rayon-climatisation-ventilation': [
    { id: 'puissance_btu', name: 'Puissance (BTU / kW)', chips: ['9000 BTU / 2,5 kW', '12000 BTU / 3,5 kW', '18000 BTU / 5 kW', '24000 BTU / 7 kW', '36000 BTU / 10 kW'] },
    { id: 'classe_energie', name: 'Classe énergétique', chips: ['A', 'A+', 'A++', 'A+++', 'B'] },
    { id: 'seer_scop', name: 'SEER / SCOP', chips: ['SEER 6', 'SEER 7', 'SEER 8', 'SEER 9', 'SCOP 3,5', 'SCOP 4', 'SCOP 4,5'] },
    { id: 'niveau_sonore', name: 'Niveau sonore (dB)', chips: ['<19 dB', '20-25 dB', '25-30 dB', '30-35 dB', '35-40 dB'] },
    { id: 'fluide', name: 'Fluide frigorigène', chips: ['R32', 'R410A', 'R290', 'R454B'] },
    { id: 'couleur', name: 'Couleur', chips: ['Blanc', 'Noir', 'Argent', 'Gris'] },
  ],

  // ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
  // RAYON 14 — Façade & Bardage
  // ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
  'rayon-facade-enduit': [
    { id: 'matiere', name: 'Matière', chips: ['Pin traité', 'Mélèze', 'Douglas', 'Bois brûlé', 'Composite', 'Fibres-ciment', 'Aluminium', 'Zinc', 'Acier Corten'] },
    { id: 'coloris_teinte', name: 'Coloris / Teinte', chips: ['Naturel', 'Gris', 'Anthracite', 'Noir', 'Blanc', 'Brun', 'Bronze', 'Sur RAL'] },
    { id: 'largeur_lame', name: 'Largeur lame (mm)', chips: ['90', '110', '120', '140', '145', '180', '200'] },
    { id: 'longueur', name: 'Longueur (m)', chips: ['2', '2,5', '3', '4', '5', '6', 'Sur mesure'] },
    { id: 'finition_bois', name: 'Finition bois', chips: ['Brut', 'Huilé', 'Lasé', 'Thermochauffé', 'Brossé', 'Autoclave Classe 4'] },
    { id: 'epaisseur', name: 'Épaisseur (mm)', chips: ['18', '21', '25', '28', '32'] },
  ],

  // ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
  // RAYON 15 — Solaire & Énergies Renouvelables
  // ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
  'rayon-energie-solaire': [
    { id: 'puissance_wc', name: 'Puissance crête (Wc)', chips: ['300 Wc', '320 Wc', '350 Wc', '375 Wc', '400 Wc', '425 Wc', '450 Wc', '500 Wc', '550 Wc'] },
    { id: 'rendement', name: 'Rendement (%)', chips: ['18%', '19%', '20%', '21%', '22%', '23%'] },
    { id: 'couleur_cadre', name: 'Couleur cadre', chips: ['Argent', 'Noir full black', 'Blanc'] },
    { id: 'couleur_cellules', name: 'Couleur cellules', chips: ['Bleu', 'Noir mono', 'Transparent'] },
    { id: 'garantie', name: 'Garantie', chips: ['10 ans produit', '25 ans produit', '25 ans performance', '30 ans performance'] },
    { id: 'capacite_batterie', name: 'Capacité batterie (kWh)', chips: ['2,5', '5', '7,5', '10', '15', '20', '30'] },
    { id: 'certification', name: 'Certification', chips: ['IEC 61215', 'IEC 61730', 'MCS', 'CEC', 'Qualipv', 'RGE'] },
  ],

  // ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
  // RAYON 16 — Outillage & Équipement
  // ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
  'rayon-outillage-equipement': [
    { id: 'alimentation', name: 'Alimentation', chips: ['Thermique', 'Électrique filaire', 'Batterie 18V', 'Batterie 36V', 'Batterie 40V', 'Solaire', 'Manuel'] },
    { id: 'puissance', name: 'Puissance (W ou cm³)', chips: ['1000W', '1500W', '1800W', '2000W', '125cm³', '163cm³', '196cm³', '305cm³'] },
    { id: 'largeur_coupe', name: 'Largeur de coupe (cm)', chips: ['30', '35', '40', '42', '45', '46', '48', '51', '53', '56', '63'] },
    { id: 'contenance_bac', name: 'Contenance bac (L)', chips: ['40L', '50L', '60L', '70L', '80L', '100L'] },
    { id: 'usage', name: 'Usage', chips: ['Particulier', 'Semi-professionnel', 'Professionnel'] },
  ],
};

// Nombre de déclinaisons affichées par défaut
export const MAX_DECLINAISONS_DEFAULT = 5;

// Fonction pour obtenir les déclinaisons d'un rayon
export function getDeclinaisonsForRayon(rayonId) {
  return DECLINAISONS_PAR_RAYON[rayonId] || [];
}

// Fonction pour initialiser les déclinaisons avec états (enabled, selectedValues)
export function initializeDeclinaisons(rayonId) {
  const declinaisons = getDeclinaisonsForRayon(rayonId);
  return declinaisons.map((d, index) => ({
    ...d,
    enabled: false, // OFF par défaut
    selectedValues: [], // Aucune valeur sélectionnée par défaut
    customValue: '', // Valeur personnalisée vide
    isVisible: index < MAX_DECLINAISONS_DEFAULT, // Seules les 5 premières sont visibles par défaut
  }));
}
